export default "__VITE_ASSET__a75b0479__"